module.exports = __webpack_public_path__ + "img/Immigration.7cf63408.svg";